$(document).ready(function () {
  // NewsLetter fix
  setTimeout(function () {
    (function () {
      // Select elements
      const input = document.querySelector(
        ".newsletter-form__field-wrapper .field__input"
      );
      const submitButton = document.querySelector(
        ".newsletter-form__field-wrapper #Subscribe"
      );

      // Create and append error message
      const errorMessage = document.createElement("p");
      errorMessage.id = "znt_78643576842";
      errorMessage.textContent = "Email format must be name@domain.com";
      errorMessage.style.color = "black";
      errorMessage.style.fontSize = "13px";
      errorMessage.style.marginTop = "5px";

      input.setAttribute("aria-describedby", errorMessage.id);
      input.insertAdjacentElement("afterend", errorMessage);

      // Disable button initially
      submitButton.setAttribute("disabled", "true");
      submitButton.setAttribute("aria-disabled", "true");

      // Function to validate email format
      function isValidEmail(email) {
        return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email);
      }

      // Event listener for input
      input.addEventListener("input", function () {
        if (isValidEmail(input.value)) {
          submitButton.removeAttribute("disabled");
          submitButton.removeAttribute("aria-disabled");
        } else {
          submitButton.setAttribute("disabled", "true");
          submitButton.setAttribute("aria-disabled", "true");
        }
      });
    })();
  }, 2000);


  // Recover login fix
setTimeout(function () {
    (function () {
        // Select elements
        const input = document.querySelector(
            '[action="/account/recover"] #RecoverEmail'
        );
        const submitButton = document.querySelector(
            '[action="/account/recover"] .button.button--primary'
        );

        // Disable button initially
        submitButton.setAttribute("disabled", "true");
        submitButton.setAttribute("aria-disabled", "true");

        // Function to validate email format
        function isValidEmail(email) {
            return /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(email);
        }

        // Event listener for input
        input.addEventListener("input", function () {
            if (isValidEmail(input.value)) {
                submitButton.removeAttribute("disabled");
                submitButton.removeAttribute("aria-disabled");
            } else {
                submitButton.setAttribute("disabled", "true");
                submitButton.setAttribute("aria-disabled", "true");
            }
        });
    })();
}, 2000);






  if (window.location.pathname !== "/") {
    setTimeout(function () {
      // // Newsletter -Footer form
      // // Sets the selectors to validate not-Globe forms
      // if ($("#ContactFooter").length) {
      //   $("#ContactFooter").addClass("g-container");
      //   $("#ContactFooter .field").addClass("globo-form-control");
      //   $("#ContactFooter .newsletter-form__field-wrapper").addClass(
      //     "block-container"
      //   );
      // }

      // Gift Card Form
      // Sets the selectors to validate not-Globe forms
      if ($("form.form").length) {
        $("form.form").addClass("g-container znt-gift-card-mod");
        $("form.form .field").addClass("globo-form-control");
        $("form.form").addClass("block-container");
        $(".recipient-email-label.optional").remove();
      }



      // Login page
      // Sets the selectors to validate not-Globe forms
      if ($("#customer_login").length) {
        $('#customer_login [for="CustomerEmail"]').text("Email *");
        $('#customer_login [for="CustomerPassword"]').text("Password *");
        $("#customer_login").addClass("g-container znt-gift-card-mod");
        $("#customer_login .field").addClass("globo-form-control");
        $("#customer_login").addClass("block-container");
      }

      // Forms Address
      if ($('[id*="address_form"]').length) {
        $('[id*="address_form"]').each(function (index) {
          var uniqueId = "ant-warning_" + index;
          $(this)
            .find('button:not([type="reset"])')
            .attr("aria-describedby", uniqueId);
          $(
            '<div id="' +
              uniqueId +
              '" class="znt-warning">The page will reload after submitting.</div>'
          ).insertAfter($(this).find('button:not([type="reset"])').parent());
        });
      }
    }, 2000);

    //Globo Wholesale Form fix by Zenyth CS
    setTimeout(function () {
      const intervalId = setInterval(() => {
        const form = document.querySelector("form.g-container");
        if (form) {
          // Forms Initial Setup

          // Removes .globo-form-input so label and input will be siblings
          $(".globo-form-input").each(function () {
            var $this = $(this);
            $this.children().insertAfter($this);
            $this.remove();
          });

          // Function to add a paragraph to the description div
          const addParagraphToDescription = (descriptionDiv) => {
            const additionalText = document.createElement("p");
            descriptionDiv.appendChild(additionalText);
          };

          // Function to enhance an input element with autocomplete and aria-required attributes
          const enhanceInput = (inputElement, autocompleteValue) => {
            if (inputElement) {
              inputElement.setAttribute("autocomplete", autocompleteValue);
            }
          };

          // Add the paragraph to the description div
          const descriptionDiv = document.querySelector(
            "div.description.globo-description"
          );
          if (descriptionDiv) {
            addParagraphToDescription(descriptionDiv);
          }

          // Autocomplete

          // First Name
          const firstNameInput = document.querySelector(
            '[placeholder="First Name"]'
          );
          enhanceInput(firstNameInput, "given-name");

          // Last Name
          const lastNameInput = document.querySelector(
            '[placeholder="Last Name"]'
          );
          enhanceInput(lastNameInput, "family-name");

          // Your Name
          const yourNameInput = document.querySelector(
            '[placeholder="Your Name"]'
          );
          enhanceInput(yourNameInput, "name");

          // Company Name
          const companyInput = document.querySelector(
            '[placeholder="Company Name"]'
          );
          enhanceInput(companyInput, "organization");

          // Billing Address - Street
          const billingAddressStreetInput = document.querySelector(
            '[placeholder="Billing Address"]'
          );
          enhanceInput(billingAddressStreetInput, "billing street-address");

          // Billing Address - City
          const billingAddressCityInput = document.querySelector(
            '[placeholder="Billing City"]'
          );
          enhanceInput(billingAddressCityInput, "billing address-level2");

          // Billing Address - State
          const billingAddressStateInput = document.querySelector(
            '[placeholder="Billing State"]'
          );
          enhanceInput(billingAddressStateInput, "billing address-level1");

          // Billing Address - Zip Code
          const billingAddressZipCodeInput = document.querySelector(
            '[placeholder="Billing ZIP"]'
          );
          enhanceInput(billingAddressZipCodeInput, "billing postal-code");

          // sHIPPING Address - Street
          const shippingAddressStreetInput = document.querySelector(
            '[placeholder="Shipping Address"]'
          );
          enhanceInput(shippingAddressStreetInput, "shipping street-address");

          // sHIPPING Address - City
          const shippingAddressCityInput = document.querySelector(
            '[placeholder="Shipping City"]'
          );
          enhanceInput(shippingAddressCityInput, "shipping address-level2");

          // sHIPPING Address - State
          const shippingAddressStateInput = document.querySelector(
            '[placeholder="Shipping State"]'
          );
          enhanceInput(shippingAddressStateInput, "shipping address-level1");

          // sHIPPING Address - Zip Code
          const shippingAddressZipCodeInput = document.querySelector(
            '[placeholder="Shipping ZIP"]'
          );
          enhanceInput(shippingAddressZipCodeInput, "shipping postal-code");

          // Business Phone
          const businessPhoneInput = document.querySelector(
            '[placeholder="Business Phone"]'
          );
          enhanceInput(businessPhoneInput, "tel");

          // Cell Phone
          const cellPhoneInput = document.querySelector(
            '[placeholder="Cell Phone"]'
          );
          enhanceInput(cellPhoneInput, "tel");

          // Enhance the email input
          const emailInput = document.querySelector(
            "input[data-type='email'][name='email']"
          );
          enhanceInput(emailInput, "email");

          // URL
          const urlInput = document.querySelector('[placeholder*="URL"]');
          enhanceInput(urlInput, "url");

          // Checks the first radio from the required radio group
          $('.flex-wrap > li:first-child input[type="radio"]').click();

          // Adds to the top os the form the required fields info
          if ($(".g-container > .header .znt-form_top-info").length === 0) {
            // If it doesn't exist, create the new element
            $(".g-container > .header").append(
              '<p class="znt-form_top-info">Fields with an asterisk (*) are required.</p>'
            );
          }

          // Adds tabindex 0 to scrollable region
          $(".globo-paragraph").attr("tabindex", "0");

          // To fieldset transformer
          const legendSelector =
            '.globo-form-control[data-type="checkbox"] > label, .globo-form-control[data-type="radio"] > label';
          const fieldsetSelector =
            '.globo-form-control[data-type="checkbox"], .globo-form-control[data-type="radio"]';

          // Function to change the tag of an element
          function changeTag(element, newTagName) {
            const newElement = document.createElement(newTagName);

            // Copy all attributes
            for (const attr of element.attributes) {
              newElement.setAttribute(attr.name, attr.value);
            }

            // Move all children
            while (element.firstChild) {
              newElement.appendChild(element.firstChild);
            }

            // Replace the old element with the new one
            element.parentNode.replaceChild(newElement, element);

            return newElement;
          }

          // Function to process elements based on selector and tag change
          function processElements(selector, newParentTag, newChildTag) {
            const elements = document.querySelectorAll(selector);

            elements.forEach((element) => {
              const newParentElement = changeTag(element, newParentTag);
              const childElements =
                newParentElement.querySelectorAll(legendSelector);

              childElements.forEach((childElement) => {
                if (
                  childElement.parentNode === newParentElement &&
                  childElement.tagName.toLowerCase() === "label"
                ) {
                  changeTag(childElement, newChildTag);
                }
              });
            });
          }

          // Process fieldset elements
          setTimeout(() => {
            processElements(fieldsetSelector, "fieldset", "legend");
          }, 2000);

          // END OF -  To fieldset transformer

          // END OF - To-fieldset transformer

          // END OF - Form Initial Setup

          /* Forms validator */

          /* Forms validator */
          /* This code runs everytime a form.g-container is added to the page dynamically */
          /* the form inputs within .globo-form-control will be validated */
          function initializeFormValidators() {
            // Main selectors/Variables
            const formSelectorZntForm = $("form.g-container");
            const formControlZnt = ".globo-form-control";
            const formFocusoutZntFallbackSelector = $('input[name*="email"]');

            // Main Event Handler
            // Responsible for field validation
            $("input, select, textarea").on("input blur", function () {
              // Get the closest label, field, and 'aria-required' attribute
              const field = $(this);
              const closestLabel = field
                .closest(formControlZnt)
                .find("label")
                .text()
                .trim();
              const ariaRequired = field.attr("aria-required") === "true";

              // Insert new line here to get 'describedById'
              // START OF - get 'describedById' for handleErrorMessage function
              const describedById = getDescribedById(
                closestLabel,
                field.attr("id")
              ); // Use field's ID as well
              // END OF - get 'describedById' for handleErrorMessage function

              // Calculate 'aria-invalid' based on your logic (this part is hypothetical)
              const ariaInvalid = calculateAriaInvalid(field, ariaRequired);

              // Call handleErrorMessage function
              handleErrorMessage(
                field,
                ariaInvalid,
                closestLabel,
                describedById
              );

              // Sets button roles and event to the dismiss button for the success messages
              const $dismissButton = $(".message.success .dismiss");
              const $messageSuccess = $(".message.success");

              if ($dismissButton.length && $messageSuccess.length) {
                // Add tabindex and role
                $dismissButton.attr("tabindex", "0");
                $dismissButton.attr("role", "button");
                $dismissButton.attr("aria-label", "Close Success Alert");

                // Function to clear content and hide the element
                const clearContent = () => {
                  $messageSuccess.empty().css("display", "none");
                };

                // Click event
                $dismissButton.on("click", clearContent);

                // Key events
                $dismissButton.on("keydown", function (event) {
                  if (event.key === "Enter") {
                    event.preventDefault(); // Prevent any default action
                    clearContent();
                  }
                });

                $dismissButton.on("keyup", function (event) {
                  if (event.key === " ") {
                    event.preventDefault(); // Prevent the page from scrolling
                    clearContent();
                  }
                });
              }

              // Tasks after validating
              $('[data-type="checkbox"] .znt-error-message').text(
                "Customer Profile is required"
              );
            });
            // END OF - Main Event Handler

            // Dummy function to avoid the Uncaught ReferenceError for calculateAriaInvalid
            const calculateAriaInvalid = () => {
              // console.log("calculateAriaInvalid called");
            };

            // Dummy function to avoid the Uncaught ReferenceError for checkFieldsZntForm
            const checkFieldsZntForm = () => {
              // console.log("checkFields called");
            };

            // Dynamic attributes and properties

            // Dynamic FOR - ID
            const handleDynamicForId = () => {
              // Select all form elements
              $("form.g-container").each(function () {
                const form = $(this); // 'form' now specifically refers to each .form
                let counter = 1;

                // Find and modify only elements within the current form
                form.find("input, select, textarea").each(function () {
                  const element = $(this);
                  let controlId = element.attr("id");
                  const commonParent = element.closest(".globo-form-control");
                  const label = commonParent.find("label").first();

                  // Case 1: Label has 'for' but element does not have 'id'
                  if (!controlId && label.attr("for")) {
                    controlId = label.attr("for");
                    element.attr("id", controlId);
                  }

                  // Case 2: Element has 'id' but label does not have 'for'
                  if (controlId && !label.attr("for")) {
                    label.attr("for", controlId);
                  }

                  // Case 3: Neither 'id' nor 'for' are present, generate new unique ID
                  if (!controlId && !label.attr("for")) {
                    const controlIdBase =
                      "znt-id_" + String(counter).padStart(2, "0");
                    const labelText = label
                      .text()
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, "");
                    controlId = `${controlIdBase}_${labelText}`;
                    element.attr("id", controlId);
                    label.attr("for", controlId);
                    counter++;
                  }

                  // Case 4: Both 'id' and 'for' are present but do not match
                  if (
                    controlId &&
                    label.attr("for") &&
                    label.attr("for") !== controlId
                  ) {
                    label.attr("for", controlId);
                  }
                });
              });
            };

            // Run the function immediately to handle all forms
            handleDynamicForId();

            // END OF - Dynamic FOR - ID

            // Required fields based on the label
            $("label").each(function () {
              const labelText = $(this).text().toLowerCase();
              const forAttribute = $(this).attr("for");

              if (labelText.includes("*") || labelText.includes("required")) {
                $(`#${forAttribute}`).attr("aria-required", "true");
              }
            });
            // END OF - Required fields based on the label

            // ARIA Attribute Updates and initial states
            const updateAriaAttributes = () => {
              formSelectorZntForm
                .find("input, select, textarea")
                .each(function () {
                  const field = $(this);
                  // Update aria-required
                  if (field.attr("required")) {
                    field.attr("aria-required", "true");
                  } else {
                    $(
                      'input:not([aria-required="true"]), select:not([aria-required="true"]), textarea:not([aria-required="true"])'
                    ).attr("aria-required", "false");
                  }
                  // Set aria-invalid to false initially
                  field.attr("aria-invalid", "false");
                });
            };
            updateAriaAttributes();
            // END OF - ARIA Attribute Updates and initial states

            // Email Validation
            const isValidEmailZntForm = (email) => {
              const emailRegex =
                /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/;
              return emailRegex.test(email);
            };

            // END OF - Email Validation

            // Focusout Fallback
            // Some forms has a focusout validation hat can conflict
            // This functions revalidates quickly on focusout
            const focusOutFallback = () => {
              formSelectorZntForm.on(
                "focusout",
                formFocusoutZntFallbackSelector,
                function () {
                  setTimeout(() => {
                    checkFieldsZntForm();
                  }, 10);
                }
              );
            };
            focusOutFallback();
            // END OF - Focusout Fallback

            // Error Message
            const getDescribedById = (label, id) => {
              return (
                "znt-" +
                label.toLowerCase().replace(/[^a-z0-9]+/g, "-") +
                "-" +
                id +
                "-error"
              );
            };

            const handleErrorMessage = (field, ariaInvalid, closestLabel) => {
              const describedById = getDescribedById(
                closestLabel,
                field.attr("id")
              );
              const formControlElement = field.closest(formControlZnt); // Get the parent form control element

              if (ariaInvalid === "true") {
                let errorMsg = closestLabel + " is required";

                if (field.is('input[name*="email"]')) {
                  errorMsg += " (name@domain.com)";
                }

                if (!$(`#${describedById}`).length) {
                  field.after(
                    `<p id="${describedById}" class="znt-error-message">${errorMsg}</p>`
                  );
                  field.attr("aria-describedby", describedById);
                  formControlElement.addClass("znt-invalid-control"); // Add the class to the parent form control element
                }
              } else {
                const observerZntForm = new MutationObserver(function (
                  mutationsList,
                  observerZntForm
                ) {
                  for (let mutation of mutationsList) {
                    if (
                      mutation.type === "attributes" &&
                      mutation.attributeName === "class"
                    ) {
                      const target = mutation.target;
                      if (
                        target.matches(formControlZnt) &&
                        !$(target).hasClass("znt-invalid-control")
                      ) {
                        $(target)
                          .find("input, textarea, select")
                          .removeAttr("aria-describedby");
                        $(target).find(".znt-error-message").remove();
                      }
                    }
                  }
                });

                const configZntForm = {
                  attributes: true,
                  attributeFilter: ["class"],
                  subtree: true,
                };
                observerZntForm.observe(document.body, configZntForm);

                // Check if any other fields in the same form control are still invalid
                const invalidFieldsInControl = formControlElement.find(
                  'input[aria-invalid="true"], select[aria-invalid="true"], textarea[aria-invalid="true"]'
                );

                if (invalidFieldsInControl.length === 0) {
                  formControlElement.removeClass("znt-invalid-control"); // Remove the class from the parent form control element
                }
              }
            };
            // END OF - Error Message

            // Define the function in a scope accessible to your main script
            function updateFormState(form) {
              // Your logic to update the form state
            }

            $(".form").each(function () {
              const form = $(this);

              if (form.children(".znt-form_live-region").length === 0) {
                const liveRegionDiv = $(
                  '<div class="znt-form_live-region" aria-live="polite" aria-atomic="true"></div>'
                );
                form.prepend(liveRegionDiv);
              }

              updateFormState(form);

              const observerZntForm = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                  if (
                    mutation.type === "attributes" &&
                    mutation.attributeName === "class"
                  ) {
                    const target = $(mutation.target);
                    if (!target.hasClass("znt-invalid-control")) {
                      updateFormState(form);
                    }
                  }
                });
              });

              const configZntForm = {
                attributes: true,
                attributeFilter: ["class"],
                subtree: true,
              };
              observerZntForm.observe(form[0], configZntForm);

              form.on(
                "input change blur",
                '[aria-required="true"], [aria-invalid]',
                function () {
                  updateFormState(form);
                }
              );
            });

            // Form tag validation for button replacement
            // Select all forms with the specified attribute
            $('.form[znt-form-validator="basic"]').each(function () {
              const form = $(this);

              // Initial state check and setup observers
              setupObservers(form);
              updateFormBlockState(form);

              // Event handlers to handle user inputs immediately
              form.on(
                "input change blur",
                "input, select, textarea",
                function () {
                  updateFormBlockState(form);
                }
              );
            });

            function setupObservers(form) {
              // Setup a MutationObserver to react to changes in attributes like 'aria-invalid'
              const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                  if (
                    mutation.type === "attributes" &&
                    (mutation.attributeName === "aria-invalid" ||
                      mutation.attributeName === "value")
                  ) {
                    updateFormBlockState(form);
                  }
                });
              });

              // Observe changes in all input fields within the form
              form.find("input, select, textarea").each(function () {
                observer.observe(this, {
                  attributes: true,
                  attributeFilter: ["aria-invalid", "value"],
                });
              });
            }

            // Function to update the blocked state of the form
            function updateFormBlockState(form) {
              let isFormBlocked = false;
              const inputs = form.find("input, select, textarea");

              inputs.each(function () {
                const input = $(this);
                // Check if the field is invalid or required and empty
                if (
                  input.attr("aria-invalid") === "true" ||
                  (input.attr("aria-required") === "true" &&
                    !input.val().trim())
                ) {
                  isFormBlocked = true;
                }
              });

              // Update the form's class based on validation results
              if (isFormBlocked) {
                form.addClass("znt-form-blocked");
              } else {
                form.removeClass("znt-form-blocked");
              }
            }
            // END OF - Form tag validation for button replacement

            // Input fields Validation (input, select, textarea)
            const inputFieldsValidation = () => {
              if ($("form").length > 0) {
                $(formSelectorZntForm).on(
                  "input focusin focusout",
                  "input, textarea",
                  function (event) {
                    const field = $(this);

                    // Skip validation for fields with aria-required="false"
                    const ariaRequired = field.attr("aria-required") === "true";
                    if (!ariaRequired) {
                      return;
                    }

                    let ariaInvalid = "false";
                    const value = field.val().trim();

                    // Check for znt-min-length attribute
                    const minLengthAttr = field.attr("znt-min-length");
                    const minLength = minLengthAttr
                      ? parseInt(minLengthAttr, 10)
                      : 0;

                    // Identify the closest label based on your HTML structure
                    const closestLabel = field
                      .closest(formControlZnt)
                      .find('label[for="' + field.attr("id") + '"]')
                      .text()
                      .replace(/[^a-zA-Z0-9 ]/g, "");

                    // On focusin, initialize hasInteracted to false
                    if (event.type === "focusin") {
                      field.data("hasInteracted", false);
                    }

                    // On input, set hasInteracted to true and validate
                    if (event.type === "input") {
                      field.data("hasInteracted", true);

                      if (field.is('input[name*="email"]')) {
                        ariaInvalid = isValidEmailZntForm(value)
                          ? "false"
                          : "true";
                      } else if (minLength > 0 && value.length < minLength) {
                        // Check for minimum length requirement
                        ariaInvalid = "true";
                      } else {
                        ariaInvalid = value === "" ? "true" : "false";
                      }

                      field.attr("aria-invalid", ariaInvalid);
                      handleErrorMessage(field, ariaInvalid, closestLabel);
                    }
                  }
                );
              }
            };

            inputFieldsValidation();

            // END OF - Input fields Validation (input, select, textarea)

            // Top Alert message
            // Prevent default behavior for all links inside .znt-form .znt-form_live-region
            $(document).on(
              "click",
              ".form .znt-form_live-region a",
              function (event) {
                event.preventDefault();
                var targetId = $(this).attr("href").substring(1); // Get the target element ID
                var targetElement = document.getElementById(targetId);

                if (targetElement) {
                  // Focus the target element without scrolling
                  targetElement.focus({ preventScroll: true });
                }
              }
            );

            // Event handler for checkboxes
            // Function to handle error messages for checkboxes
            function handleCheckboxErrorMessage(checkbox) {
              const describedById =
                "error-" + Math.random().toString(36).substr(2, 9); // Generate a random ID
              const labelContent = checkbox
                .closest(".globo-form-control")
                .find("label")
                .text()
                .trim()
                .replace("*", ""); // Remove the asterisk
              const errorMessage = `<p id="${describedById}" class="znt-error-message">${labelContent} is required</p>`;

              if (checkbox.prop("checked")) {
                checkbox.attr("aria-invalid", "false");
                checkbox
                  .closest(".globo-form-control")
                  .removeClass("znt-invalid-control");
                checkbox.removeAttr("aria-describedby");
                checkbox
                  .closest(".globo-form-control")
                  .find(".znt-error-message")
                  .remove();
              } else {
                checkbox.attr("aria-invalid", "true");
                checkbox
                  .closest(".globo-form-control")
                  .addClass("znt-invalid-control");
                if (
                  !checkbox
                    .closest(".globo-form-control")
                    .find(".znt-error-message").length
                ) {
                  checkbox.closest(".globo-form-control").append(errorMessage);
                  checkbox.attr("aria-describedby", describedById);
                }
              }

              updateFormBlockState(checkbox.closest("form")); // Update the form block state based on the checkbox state
            }

            // Event handler for checkboxes
            $('input[type="checkbox"][aria-required="true"]').on(
              "change",
              function () {
                handleCheckboxErrorMessage($(this));
              }
            );
            // END OF - Event handler for checkboxes

            // Event handler for <select>
            function handleSelectErrorMessage(select) {
              const formControl = select.closest(".globo-form-control");
              const describedById =
                "error-" + Math.random().toString(36).substr(2, 9); // Generate a random ID
              const labelContent = formControl
                .find("label")
                .text()
                .trim()
                .replace("*", ""); // Remove the asterisk
              const errorMessage = `<p id="${describedById}" class="znt-error-message">${labelContent} is required</p>`;

              if (select.val().trim() !== "") {
                select.attr("aria-invalid", "false");
                formControl.removeClass("znt-invalid-control");
                select.removeAttr("aria-describedby");
                formControl.find(".znt-error-message").remove();
              } else {
                select.attr("aria-invalid", "true");
                formControl.addClass("znt-invalid-control");
                if (formControl.find(".znt-error-message").length === 0) {
                  formControl.append(errorMessage);
                  select.attr("aria-describedby", describedById);
                }
              }

              updateFormBlockState(select.closest("form")); // Update the form block state based on the select state
            }

            // Event handler for select elements
            $('select[aria-required="true"]').one("focus", function () {
              $(this).data("hasInteracted", true);
            });

            $('select[aria-required="true"]').on("change", function () {
              if ($(this).data("hasInteracted")) {
                handleSelectErrorMessage($(this));
              }
            });

            // END OF - Event handler for <select>
          }
          // Function to initialize the MutationObserver
          function observeNewForms() {
            // Callback function to execute when mutations are observed
            const callback = function (mutationsList, observer) {
              for (const mutation of mutationsList) {
                if (mutation.type === "childList") {
                  mutation.addedNodes.forEach((node) => {
                    if (
                      node.nodeType === Node.ELEMENT_NODE &&
                      node.matches("form.g-container")
                    ) {
                      setTimeout(function () {
                        initializeFormValidators();
                      }, 2000);
                    }
                  });
                }
              }
            };

            // Create an observer instance linked to the callback function
            const observer = new MutationObserver(callback);

            // Start observing the target node for configured mutations
            observer.observe(document.body, { childList: true, subtree: true });

            // Optionally, run the function on existing forms when the observer is initialized
            document
              .querySelectorAll("form.g-container")
              .forEach((form) => initializeFormValidators());
          }

          // Run the observer function to start watching for new forms
          observeNewForms();

          // Savanaah Bee Mod
          // Validates all fileds on submit

          // Observer for .errors class addition
          function observeErrorsClass() {
            const targetNode = document.querySelector(".block-container");
            const config = { attributes: true, attributeFilter: ["class"] };

            const callback = function (mutationsList) {
              for (const mutation of mutationsList) {
                if (
                  mutation.type === "attributes" &&
                  mutation.target.classList.contains("errors")
                ) {
                  $("form.g-container")
                    .find(
                      'input, select, textarea, input[type="checkbox"][aria-required="true"]'
                    )
                    .each(function () {
                      // Trigger the existing validation logic on each field
                      $(this).trigger("input");
                      if ($(this).is('input[type="checkbox"]')) {
                        $(this).trigger("change");
                      }
                    });
                }
              }
            };

            if (targetNode) {
              const observer = new MutationObserver(callback);
              observer.observe(targetNode, config);
            }
          }

          // Run the observer function to start watching for .errors class addition
          observeErrorsClass();

          // END OF - Savanaah Bee Mod

          /* END OF - Forms validator */

          clearInterval(intervalId); // Stop the interval
        }
      }, 500); // Check every 500 milliseconds
    }, 2000);

    //Globo Wholesale Form fix by Zenyth CS

    // Function to check the form's validity
    // Checks if there is a invalid field to keep the submit button disabled
    // Array of form selectors
    let formSelectors = ["#contactForm", "#customer_login"];
    let submitButtonSelectors = ["#contactFormSubmit", "#customer_login .button.button--primary"];
    let emailFieldSelectors = ["#c-email"];

    console.log('TESTE@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@');

    function checkFormValidity() {
      formSelectors.forEach((formSelector, index) => {
        let requiredFields = $(`${formSelector} [aria-required="true"]`);
        let allFieldsValid = true;

        requiredFields.each(function () {
          let fieldValue = $(this).val();
          if (
            $(this).attr("aria-invalid") === "true" ||
            fieldValue === null ||
            fieldValue.trim() === ""
          ) {
            allFieldsValid = false;
            return false; // Break out of each loop
          }
        });

        let submitButton = $(submitButtonSelectors[index]);
        let emailField = $(emailFieldSelectors[index]);
        let infoParagraphId = `formInfo-${index}`; // Dynamically set the paragraph ID
        let infoParagraph = $(`#${infoParagraphId}`);

        if (!allFieldsValid) {
          submitButton.prop("disabled", true);
          submitButton.attr("aria-disabled", "true");

          // Remove aria-describedby and paragraph if button is disabled
          emailField.removeAttr("aria-describedby");
          if (infoParagraph.length) {
            infoParagraph.remove();
          }
        } else {
          submitButton.prop("disabled", false);
          submitButton.removeAttr("aria-disabled");

          // Add aria-describedby and paragraph if button is enabled
          if (infoParagraph.length === 0) {
            emailField.after(
              `<p id="${infoParagraphId}" class="znt-warning">The page will reload after submitting.</p>`
            );
          }
          emailField.attr("aria-describedby", infoParagraphId);
        }
      });
    }

    // Initially disable the submit buttons
    submitButtonSelectors.forEach((submitButtonSelector) => {
      $(submitButtonSelector)
        .prop("disabled", true)
        .attr("aria-disabled", "true");
    });

    // Initial check on page load
    checkFormValidity();

    // MutationObserver configuration
    let observerConfig = {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-invalid", "value"],
    };

    // Create a MutationObserver instance
    let observer = new MutationObserver(function (mutationsList) {
      // When a mutation is observed, check the form's validity
      checkFormValidity();
      console.log("test");
    });

    // Select the target nodes (forms) to observe
    formSelectors.forEach((formSelector) => {
      let targetNode = document.querySelector(formSelector);
      // Start observing the target node for configured mutations
      if (targetNode) {
        observer.observe(targetNode, observerConfig);
      }
    });

    // Manually trigger a mutation for testing purposes
    setTimeout(function () {
      $(emailFieldSelectors[0]).attr("aria-invalid", "true");
      checkFormValidity(); // Ensure state is checked immediately after mutation
    }, 2000);

    console.log("Not Homepage");
  }

  // Wholesale Page
  var currentPathWholesale = window.location.pathname;

  // Check if the path matches "/pages/wholesale-form"
  if (currentPathWholesale === "/pages/wholesale-form") {
    // Status message
    // Removing HTML5 validation from Reset Password form
    console.log("Whosale");
    // Check if the form element exists on the page before proceeding
    const formElement = $("form[action='/account/recover']");
    if (formElement.length) {
      // Add the 'novalidate' attribute to the form
      formElement.attr("novalidate", "novalidate");
    }

    // Whosale success message fix

    var observerSuccess = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        var messageSuccess = $(".message.success");
        if (
          messageSuccess.length &&
          messageSuccess.css("display") === "block"
        ) {
          setTimeout(function () {
            messageSuccess.attr("tabindex", "-1").focus();
            var dismissSuccess = messageSuccess.find(".dismiss");
            dismissSuccess.attr({
              role: "button",
              tabindex: "0",
            });

            dismissSuccess.on("keydown", function (e) {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                $(this).click();
              }
            });

            dismissSuccess.on("keyup", function (e) {
              if (e.key === " ") {
                e.preventDefault();
                $(this).click();
              }
            });
          }, 1000);
        }
      });
    });

    observerSuccess.observe(document.body, { childList: true, subtree: true });

    // Select the element to observe
    const targetNodeGiftPage = document.querySelector(
      ".product-form__error-message"
    );

    // Set up the options for the observer
    const configGiftPage = { childList: true };

    // Define a callback function to execute when mutations are observed
    const callbackGiftPage = function (
      mutationsListGiftPage,
      observerGiftPage
    ) {
      for (let mutationGiftPage of mutationsListGiftPage) {
        // Check if a child node (span) was added
        if (
          mutationGiftPage.type === "childList" &&
          mutationGiftPage.addedNodes.length > 0
        ) {
          for (let nodeGiftPage of mutationGiftPage.addedNodes) {
            if (nodeGiftPage.nodeName === "SPAN") {
              // Append the required content
              $(nodeGiftPage).append(" (name@domain.com)");

              // Stop observing after the task is done
              observerGiftPage.disconnect();
              break;
            }
          }
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observerGiftPage = new MutationObserver(callbackGiftPage);

    // Start observing the target node for configured mutations
    if (targetNodeGiftPage) {
      observerGiftPage.observe(targetNodeGiftPage, configGiftPage);
    }
    // END OF - Status message

    // ShortCodes
    // Function to process the .globo-paragraph elements
    function processGloboParagraphs() {
      $(".globo-paragraph").each(function () {
        var content = $(this).html();

        if (content.includes("[znt-list")) {
          var regex = /\[znt-list(.*?)\](.*?)\[END OF - znt-list\]/gs;

          var updatedContent = content.replace(
            regex,
            function (match, classes, p1) {
              var classNames = classes.trim();
              var listItems = p1
                .split(/<\/?p>|<br\s*\/?>|\n/)
                .filter(function (item) {
                  return item.trim() !== "";
                });

              var listContent = listItems
                .map(function (item) {
                  var content = item.trim();
                  return content ? "<li>" + content + "</li>" : "";
                })
                .join("");

              if (listItems.length === 1) {
                return "<p>" + listItems[0].trim() + "</p>";
              } else {
                return listContent
                  ? `<ul class="znt-list ${classNames}">${listContent}</ul>`
                  : "";
              }
            }
          );

          if (!content.includes("[END OF - znt-list]")) {
            console.error("Missing closing shortcode '[END OF - znt-list]'.");
          }

          $(this).html(updatedContent);
        }
      });
    }

    function contentCleanUp() {
      $(".globo-paragraph p").each(function () {
        var $this = $(this);

        if (
          $this.children().length === 1 &&
          $this.children("br").length === 1
        ) {
          $this.replaceWith('<div class="znt-spacing"></div>');
        }
      });

      $(".globo-paragraph p").each(function () {
        var $this = $(this);

        if ($this.is(":empty")) {
          $this.remove();
        }
      });
    }

    var checkInterval = setInterval(function () {
      if ($(".globo-paragraph").length > 0) {
        processGloboParagraphs();
        contentCleanUp();
        clearInterval(checkInterval);
      }
    }, 500);

    // END OF - ShortCodes
  }
  // END OF - Wholesale Page
});



